import { de_GetOrderByAccessIdCommand, se_GetOrderByAccessIdCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetOrderByAccessIdCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "GetOrderByAccessId", {})
    .n("ApiClient", "GetOrderByAccessIdCommand")
    .f(void 0, void 0)
    .ser(se_GetOrderByAccessIdCommand)
    .de(de_GetOrderByAccessIdCommand)
    .build() {
}
